export default "__VITE_ASSET__cwrBpfm4__"